import OneLoanQuotationLayout from "components/import/OneLoanQuotationLayout";

function OneLoanQuotation(props: any) {

    return (
        <OneLoanQuotationLayout props={props} />
    );
}

export default OneLoanQuotation;